/* Mastoner canonical promotion card bootstrap. */
(() => {
  if (typeof document === "undefined" || typeof customElements === "undefined" || !document.head) return;
  const styleId = "mastoner-promotion-card-styles";
  if (!document.getElementById(styleId)) {
    const style = document.createElement("style");
    style.id = styleId;
    style.textContent = "mastoner-promotion-card-label[hidden] {\n    display: none !important;\n  }\n  .product-label--supplier-promotion {\n    background: #12633e;\n    color: #fff;\n    font-size: 11px;\n    line-height: 1.35;\n    padding: 5px 7px;\n    white-space: normal;\n  }";
    document.head.append(style);
  }
if (!customElements.get('mastoner-promotion-card-label')) {
    const madrid = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    });
    const partsAt = (epoch) => Object.fromEntries(madrid.formatToParts(new Date(epoch)).map(({ type, value }) => [type, value]));
    const validDay = (value) => {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value ?? '')) return false;
      const epoch = Date.parse(value + 'T00:00:00.000Z');
      return Number.isFinite(epoch) && new Date(epoch).toISOString().slice(0, 10) === value;
    };
    const afterEndDay = (value) => {
      const [year, month, day] = value.split('-').map(Number);
      const desired = Date.UTC(year, month - 1, day + 1);
      let epoch = desired;
      for (let iteration = 0; iteration < 3; iteration += 1) {
        const p = partsAt(epoch);
        epoch += desired - Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day), Number(p.hour), Number(p.minute), Number(p.second));
      }
      return epoch;
    };
    customElements.define('mastoner-promotion-card-label', class extends HTMLElement {
      connectedCallback() {
        this.onVisibility = () => this.reconcile();
        document.addEventListener('visibilitychange', this.onVisibility);
        this.reconcile();
      }
      disconnectedCallback() {
        clearTimeout(this.expiryTimer);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }
      reconcile() {
        clearTimeout(this.expiryTimer);
        const data = this.dataset;
        const now = Date.now();
        const p = partsAt(now);
        const today = `${p.year}-${p.month}-${p.day}`;
        const fresh = Date.parse(data.freshUntil ?? '');
        const valid = data.contractVersion === 'mastoner-promotion-publication.v1' &&
          data.state === 'active' && Boolean(data.providerId?.trim()) &&
          Boolean(data.supplierSku?.trim()) && Boolean(data.promotionCode?.trim()) &&
          /^[a-f0-9]{64}$/.test(data.pricingDecisionHash ?? '') &&
          validDay(data.startsOn) && validDay(data.endsOn) &&
          today >= data.startsOn && today <= data.endsOn && fresh > now;
        this.hidden = !valid;
        if (valid) {
          const expiresAt = Math.min(fresh, afterEndDay(data.endsOn));
          this.expiryTimer = setTimeout(() => this.reconcile(), Math.min(2147483647, Math.max(1, expiresAt - now)));
        }
      }
    });
  }
})();
/* global document, window, URL, AbortController, DOMParser, setTimeout, clearTimeout */

(() => {
  const makeRequest = (href) => {
    const url = new URL(href);
    const match = url.pathname.match(
      /^(\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?)(?:collections)\/([a-z0-9-]+)\/?$/i,
    );
    if (!match) return null;
    for (const [key, value] of url.searchParams) {
      if (/^(?:filter(?:[._]|\[)|sort_by$|q$|constraint$)/i.test(key)) return null;
      if (key === "page" && !/^[1-9]\d{0,5}$/.test(value)) return null;
    }
    url.pathname = `${match[1]}a/search/${match[2]}`;
    url.hash = "";
    url.searchParams.set("cloud_search_section_id", "collection-products");
    url.searchParams.set("sort_by", "relevance");
    return { url, handle: match[2] };
  };

  const validatePage = (page, request, expectedCount) => {
    const roots = page.querySelectorAll("[data-mastoner-stock-first-handle]");
    if (roots.length !== 1 || roots[0].dataset.mastonerStockFirstHandle !== request.handle) {
      throw new Error("collection_mismatch");
    }
    const root = roots[0];
    if (!/^\d+$/.test(root.dataset.numResults)) throw new Error("invalid_collection_count");
    if (expectedCount !== undefined && root.dataset.numResults !== expectedCount)
      throw new Error("collection_count_changed");
    const count = Number(root.dataset.numResults);
    const grids = root.querySelectorAll("#filter-results");
    if (grids.length !== 1) throw new Error("results_missing");
    const grid = grids[0];
    const expectedPage = Number(request.url.searchParams.get("page") || "1");
    const pageSize = Number(grid.dataset.stockFirstPageSize);
    if (
      Number(grid.dataset.stockFirstPage) !== expectedPage ||
      !Number.isInteger(pageSize) ||
      pageSize < 1
    ) {
      throw new Error("pagination_page_mismatch");
    }
    const links = [...grid.querySelectorAll('product-card a[href*="/products/"]')];
    const handles = new Set(
      links.map((link) => new URL(link.href, request.url).pathname.split("/products/")[1]),
    );
    if (count > 0 && handles.size === 0) throw new Error("products_missing");
    const cards = grid.querySelectorAll("product-card");
    if (handles.size !== cards.length) throw new Error("duplicate_products");
    if (cards.length !== Math.max(0, Math.min(pageSize, count - (expectedPage - 1) * pageSize))) {
      throw new Error("incomplete_page");
    }
    for (const link of grid.querySelectorAll(".pagination a[href], .js-pagination a[href]")) {
      const url = new URL(link.getAttribute("href"), request.url);
      if (url.origin !== request.url.origin || url.pathname !== request.url.pathname) {
        throw new Error("pagination_scope_mismatch");
      }
      if (
        [...url.searchParams].some(
          ([key, value]) =>
            /^(?:filter(?:[._]|\[)|sort_by$)/i.test(key) &&
            !(
              key === "sort_by" &&
              value === "relevance" &&
              value === request.url.searchParams.get("sort_by") &&
              url.searchParams.getAll(key).length === 1
            ),
        )
      ) {
        throw new Error("unexpected_pagination_filter");
      }
    }
    grid.dataset.stockFirstCount = String(count);
    return grid;
  };

  const rootOf = (pagination) => pagination.closest("[data-mastoner-stock-first-handle]");
  const owns = (pagination) => {
    const request = makeRequest(window.location.href);
    return !!request && rootOf(pagination)?.dataset.mastonerStockFirstHandle === request.handle;
  };
  const canonicalize = (grid, href) => {
    const canonical = new URL(href);
    for (const link of grid.querySelectorAll(".pagination a[href], .js-pagination a[href]")) {
      const url = new URL(link.getAttribute("href"), canonical);
      url.pathname = canonical.pathname;
      url.searchParams.delete("cloud_search_section_id");
      url.searchParams.delete("sort_by");
      for (const [key, value] of canonical.searchParams) {
        if (key !== "page") url.searchParams.set(key, value);
      }
      link.setAttribute("href", url.href);
    }
  };
  const prepareGrid = (page, request, count, href) => {
    const grid = validatePage(page, request, count);
    grid
      .querySelectorAll('script:not([type="application/json"]):not([type="application/ld+json"])')
      .forEach((script) => script.remove());
    canonicalize(grid, href);
    return grid;
  };
  const pageNumber = (href) =>
    Number(new URL(href, window.location.href).searchParams.get("page") || "1");
  const active = new Map();
  const settle = (root, state) => {
    root.dataset.stockFirstState = state;
    root.querySelector("#filter-results")?.removeAttribute("aria-busy");
    const status = root.querySelector("[data-stock-first-loading]");
    if (status) status.hidden = true;
    document.dispatchEvent(
      new window.CustomEvent("mastoner:stock-first:settled", { detail: { root, state } }),
    );
  };

  const fetchPage = async (pagination, href, options) => {
    const root = rootOf(pagination);
    const request = makeRequest(href);
    if (!owns(pagination) || root.dataset.stockFirstState !== "ready") {
      return window.fetch(href, { signal: options.signal });
    }
    if (
      !request ||
      request.handle !== root.dataset.mastonerStockFirstHandle ||
      request.url.origin !== new URL(window.location.href).origin
    )
      throw new Error("pagination_scope_mismatch");
    const controller = new AbortController();
    const cancel = () => controller.abort();
    options.signal?.addEventListener("abort", cancel, { once: true });
    if (options.signal?.aborted) cancel();
    const timer = setTimeout(cancel, 8000);
    try {
      const startedHref = window.location.href;
      const response = await window.fetch(request.url.href, {
        signal: controller.signal,
        credentials: "same-origin",
      });
      if (!response.ok || response.redirected) throw new Error("source_unavailable");
      const html = await response.text();
      if (html.length > 2000000) throw new Error("source_too_large");
      const grid = prepareGrid(
        new DOMParser().parseFromString(html, "text/html"),
        request,
        root.dataset.numResults,
        href,
      );
      if (
        controller.signal.aborted ||
        !pagination.isConnected ||
        window.location.href !== startedHref ||
        root.dataset.stockFirstState !== "ready"
      )
        throw new Error("stale_response");
      const loaded = [...pagination.querySelectorAll(".js-pagination-result")];
      const existing = new Set(
        loaded.map((item) => item.querySelector('a[href*="/products/"]')?.pathname),
      );
      for (const item of grid.querySelectorAll(".js-pagination-result")) {
        if (existing.has(item.querySelector('a[href*="/products/"]')?.pathname))
          throw new Error("duplicate_page_product");
      }
      // Restoring an earlier page must keep the next link of the highest loaded page.
      if (loaded.some((item) => pageNumber(item.dataset.paginationPageUrl) > pageNumber(href))) {
        const next = grid.querySelector(".js-pagination");
        const current = pagination.querySelector(".js-pagination");
        if (next && current) next.replaceWith(current.cloneNode(true));
        else next?.remove();
      }
      return { ok: true, text: async () => grid.outerHTML };
    } finally {
      clearTimeout(timer);
      options.signal?.removeEventListener("abort", cancel);
    }
  };
  const orderResults = (pagination) => {
    if (!owns(pagination) || rootOf(pagination).dataset.stockFirstState !== "ready") return;
    const results = [...pagination.querySelectorAll(".js-pagination-result")];
    const parent = results[0]?.parentElement;
    results.sort(
      (a, b) => pageNumber(a.dataset.paginationPageUrl) - pageNumber(b.dataset.paginationPageUrl),
    );
    results.forEach((result) => parent.append(result));
  };

  const boot = async () => {
    const startedHref = window.location.href;
    const request = makeRequest(startedHref);
    if (!request || window.Shopify?.designMode) return;
    const root = document.querySelector("[data-mastoner-stock-first-handle]");
    if (
      !root ||
      root.dataset.mastonerStockFirstHandle !== request.handle ||
      root.dataset.stockFirstState === "ready" ||
      active.has(root)
    )
      return;
    if (
      root.dataset.stockFirstState === "fallback" &&
      Number(root.dataset.stockFirstDeadline) < Date.now()
    )
      return;
    const target = root.querySelector("#filter-results");
    const pagination = target?.closest("custom-pagination");
    if (!target || !pagination) return;
    const controller = new AbortController();
    let changedByUser = false;
    const cancel = () => {
      changedByUser = true;
      controller.abort();
      active.delete(root);
      pagination.dataset.pauseInfiniteScroll = previousPause || "false";
      settle(root, "cancelled");
    };
    const onInteraction = (event) => {
      if (
        event.target?.closest(
          "products-toolbar, .mastoner-xcloud-sidebar, .main-products-grid__filters, #cloud_search_filters_root, .js-pagination",
        )
      )
        cancel();
    };
    document.addEventListener("change", onInteraction, { capture: true });
    document.addEventListener("click", onInteraction, { capture: true });
    window.addEventListener("popstate", cancel);
    window.addEventListener("pagehide", cancel);
    root.dataset.stockFirstState = "loading";
    active.set(root, controller);
    const status = root.querySelector("[data-stock-first-loading]");
    if (status) status.hidden = false;
    target.setAttribute("aria-busy", "true");
    const previousPause = pagination.dataset.pauseInfiniteScroll;
    pagination.dataset.pauseInfiniteScroll = "true";
    pagination.controller?.abort();
    pagination.stockFirstRestoreController?.abort();
    const deadline = Number(root.dataset.stockFirstDeadline) || Date.now() + 8000;
    const timer = setTimeout(
      () => {
        if (active.get(root) !== controller) return;
        controller.abort();
        settle(root, "fallback");
      },
      Math.max(0, deadline - Date.now()),
    );
    try {
      const response = await window.fetch(request.url.href, {
        credentials: "same-origin",
        signal: controller.signal,
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      if (!response.ok || response.redirected) throw new Error("source_unavailable");
      const html = await response.text();
      if (html.length > 2000000) throw new Error("source_too_large");
      const page = new DOMParser().parseFromString(html, "text/html");
      const source = prepareGrid(
        page,
        request,
        root.dataset.stockFirstRefreshCount === "true" ? undefined : root.dataset.numResults,
        startedHref,
      );
      if (
        controller.signal.aborted ||
        changedByUser ||
        root.dataset.stockFirstState !== "loading" ||
        window.location.href !== startedHref ||
        !target.isConnected
      ) {
        throw new Error("stale_response");
      }
      // Only the product grid and its existing pagination are replaced. The
      // collection URL, headings, canonical, toolbar and facet owner stay intact.
      // Inert fragment scripts are never executed.
      target.replaceChildren(...source.childNodes);
      target.dataset.stockFirstPage = source.dataset.stockFirstPage;
      target.dataset.stockFirstPageSize = source.dataset.stockFirstPageSize;
      target.dataset.stockFirstCount = source.dataset.stockFirstCount;
      root.dataset.numResults = source.dataset.stockFirstCount;
      delete root.dataset.stockFirstRefreshCount;
      target.querySelectorAll(".js-pagination-result").forEach((result) => {
        result.dataset.paginationPageUrl = startedHref;
      });
      root.dataset.stockFirstState = "ready";
      pagination.dataset.pauseInfiniteScroll = previousPause || "false";
      pagination.reload?.();
      settle(root, "ready");
      document.dispatchEvent(
        new window.CustomEvent("mastoner:stock-first:ready", {
          detail: { handle: request.handle, count: Number(root.dataset.numResults) },
        }),
      );
    } catch {
      if (active.get(root) === controller) settle(root, changedByUser ? "cancelled" : "fallback");
    } finally {
      clearTimeout(timer);
      if (active.get(root) === controller) {
        target.removeAttribute("aria-busy");
        active.delete(root);
        if (root.dataset.stockFirstState !== "ready")
          pagination.dataset.pauseInfiniteScroll = previousPause || "false";
        if (status) status.hidden = true;
      }
      document.removeEventListener("change", onInteraction, { capture: true });
      document.removeEventListener("click", onInteraction, { capture: true });
      window.removeEventListener("popstate", cancel);
      window.removeEventListener("pagehide", cancel);
    }
  };

  if (typeof document !== "undefined") {
    window.MastonerCollectionStockFirst = { owns, fetchPage, orderResults };
    document.addEventListener("on:facet-filters:updated", () => {
      const root = document.querySelector("[data-mastoner-stock-first-handle]");
      if (!root) return;
      active.get(root)?.abort();
      active.delete(root);
      const pagination = root.querySelector("#filter-results")?.closest("custom-pagination");
      pagination?.stockFirstRestoreController?.abort();
      pagination?.controller?.abort();
      root.dataset.stockFirstState = "native";
      if (makeRequest(window.location.href)) {
        root.dataset.stockFirstRefreshCount = "true";
        root.dataset.stockFirstDeadline = String(Date.now() + 8000);
        void boot();
      } else settle(root, "native");
    });
    window.addEventListener("pageshow", (event) => {
      if (!event.persisted) return;
      const root = document.querySelector("[data-mastoner-stock-first-handle]");
      if (!root || !makeRequest(window.location.href)) return;
      if (root.dataset.stockFirstState === "ready") {
        root.querySelector("custom-pagination")?.reload?.();
        return;
      }
      root.dataset.stockFirstDeadline = String(Date.now() + 8000);
      void boot();
    });
    if (document.readyState === "loading")
      document.addEventListener("DOMContentLoaded", boot, { once: true });
    else void boot();
  }
  return { makeRequest, validatePage, boot, canonicalize, owns, fetchPage, orderResults };
})();
